// Theme: synthwave
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'synthwave',
  name: 'SYNTHWAVE',
  tagline: 'SYNTHWAVE',
  description: 'Grid neon dos anos 80. Magenta fluorescente sobre roxo profundo.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 2000,
  swatches: ['#0A0820', '#FF006E', '#1A1040', '#FFD6EC'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '2px',
      '--radius': '4px',
      '--shadow-card': '0 14px 36px rgba(255, 0, 110, 0.10)',
      '--shadow-card-active': '0 16px 40px rgba(255, 0, 110, 0.10)'
    },
    shellClasses: 'font-mono theme-synthwave'
  },
  colorVars: {
    '--accent': '#FF006E',
    '--accent-foreground': '#0A0820',
    '--background': '#0A0820',
    '--border': '#6B2D8F',
    '--card': '#1A1040',
    '--card-border-active': 'rgba(255, 0, 110, 0.10)',
    '--card-completed': '#231651',
    '--card-foreground': '#FFD6EC',
    '--card-glow': 'rgba(255, 0, 110, 0.10)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0820',
    '--foreground': '#FFD6EC',
    '--hold-fill': '#FF006E',
    '--input': '#1A1040',
    '--modal-bg': '#0A0820',
    '--modal-border': '#6B2D8F',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(255, 0, 110, 0.10)',
    '--muted': '#1A1040',
    '--muted-foreground': '#C28AD8',
    '--nav-active': '#FF006E',
    '--nav-bg': '#0A0820',
    '--popover': '#1A1040',
    '--popover-foreground': '#FFD6EC',
    '--primary': '#FF006E',
    '--primary-foreground': '#0A0820',
    '--ring': '#FF006E',
    '--secondary': '#6B2D8F',
    '--secondary-foreground': '#FFD6EC',
    '--streak': '#FF006E',
    '--success': '#22c55e',
    '--success-foreground': '#0A0820',
    '--xp': '#FF006E',
    '--xp-bg': '#1A1040'
  },
  resolvedVars: {
    '--accent': '#FF006E',
    '--accent-foreground': '#0A0820',
    '--accent-foreground-hsl': '245 60% 8%',
    '--accent-foreground-oklch': 'from #0A0820 l c h',
    '--accent-hsl': '334 100% 50%',
    '--accent-oklch': 'from #FF006E l c h',
    '--background': '#0A0820',
    '--background-hsl': '245 60% 8%',
    '--background-oklch': 'from #0A0820 l c h',
    '--border': '#6B2D8F',
    '--border-hsl': '278 52% 37%',
    '--border-oklch': 'from #6B2D8F l c h',
    '--border-w': '2px',
    '--card': '#1A1040',
    '--card-border-active': 'rgba(255, 0, 110, 0.10)',
    '--card-completed': '#231651',
    '--card-completed-hsl': '253 57% 20%',
    '--card-completed-oklch': 'from #231651 l c h',
    '--card-foreground': '#FFD6EC',
    '--card-foreground-hsl': '328 100% 92%',
    '--card-foreground-oklch': 'from #FFD6EC l c h',
    '--card-glow': 'rgba(255, 0, 110, 0.10)',
    '--card-hsl': '252 60% 16%',
    '--card-oklch': 'from #1A1040 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A0820',
    '--destructive-foreground-hsl': '245 60% 8%',
    '--destructive-foreground-oklch': 'from #0A0820 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FFD6EC',
    '--foreground-hsl': '328 100% 92%',
    '--foreground-oklch': 'from #FFD6EC l c h',
    '--hold-fill': '#FF006E',
    '--hold-fill-hsl': '334 100% 50%',
    '--hold-fill-oklch': 'from #FF006E l c h',
    '--input': '#1A1040',
    '--input-hsl': '252 60% 16%',
    '--input-oklch': 'from #1A1040 l c h',
    '--modal-bg': '#0A0820',
    '--modal-bg-hsl': '245 60% 8%',
    '--modal-bg-oklch': 'from #0A0820 l c h',
    '--modal-border': '#6B2D8F',
    '--modal-border-hsl': '278 52% 37%',
    '--modal-border-oklch': 'from #6B2D8F l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(255, 0, 110, 0.10)',
    '--muted': '#1A1040',
    '--muted-foreground': '#C28AD8',
    '--muted-foreground-hsl': '283 50% 69%',
    '--muted-foreground-oklch': 'from #C28AD8 l c h',
    '--muted-hsl': '252 60% 16%',
    '--muted-oklch': 'from #1A1040 l c h',
    '--nav-active': '#FF006E',
    '--nav-active-hsl': '334 100% 50%',
    '--nav-active-oklch': 'from #FF006E l c h',
    '--nav-bg': '#0A0820',
    '--nav-bg-hsl': '245 60% 8%',
    '--nav-bg-oklch': 'from #0A0820 l c h',
    '--popover': '#1A1040',
    '--popover-foreground': '#FFD6EC',
    '--popover-foreground-hsl': '328 100% 92%',
    '--popover-foreground-oklch': 'from #FFD6EC l c h',
    '--popover-hsl': '252 60% 16%',
    '--popover-oklch': 'from #1A1040 l c h',
    '--primary': '#FF006E',
    '--primary-foreground': '#0A0820',
    '--primary-foreground-hsl': '245 60% 8%',
    '--primary-foreground-oklch': 'from #0A0820 l c h',
    '--primary-hsl': '334 100% 50%',
    '--primary-oklch': 'from #FF006E l c h',
    '--radius': '4px',
    '--ring': '#FF006E',
    '--ring-hsl': '334 100% 50%',
    '--ring-oklch': 'from #FF006E l c h',
    '--secondary': '#6B2D8F',
    '--secondary-foreground': '#FFD6EC',
    '--secondary-foreground-hsl': '328 100% 92%',
    '--secondary-foreground-oklch': 'from #FFD6EC l c h',
    '--secondary-hsl': '278 52% 37%',
    '--secondary-oklch': 'from #6B2D8F l c h',
    '--shadow-card': '0 14px 36px rgba(255, 0, 110, 0.10)',
    '--shadow-card-active': '0 16px 40px rgba(255, 0, 110, 0.10)',
    '--streak': '#FF006E',
    '--streak-hsl': '334 100% 50%',
    '--streak-oklch': 'from #FF006E l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A0820',
    '--success-foreground-hsl': '245 60% 8%',
    '--success-foreground-oklch': 'from #0A0820 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(334 100% 50% / 0.15)',
    '--xp': '#FF006E',
    '--xp-bg': '#1A1040',
    '--xp-bg-hsl': '252 60% 16%',
    '--xp-bg-oklch': 'from #1A1040 l c h',
    '--xp-hsl': '334 100% 50%',
    '--xp-oklch': 'from #FF006E l c h'
  }
}
